// extracted by mini-css-extract-plugin
module.exports = {"container":"singlePartMob__container___1DPEF","buttons":"singlePartMob__buttons___1mh5e"};